export const actions = {
  set: 'SET::CONTRACTOR_ACTIVE_FILTER'
}

export const setContractorActiveFilter = filter => ({ type: actions.set, contractorActiveFilter: filter })
export const getContractorActiveFilter = state => state.contractorActiveFilter

export default actions



// WEBPACK FOOTER //
// ./src/store/contractor-active-filter/actions.js